<div [formGroup]="editForm()">
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addSection()"
  >
    <mat-icon>post_add</mat-icon>
    <span i18n>Add Section</span>
  </button>
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addField()"
  >
    <mat-icon>note_add</mat-icon>
    <span i18n>Add Field</span>
  </button>
  @if (isAttachmentOnly()) {
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addDeviceAttributeFields()"
    i18n-matTooltip="@@addDeviceAttributeFieldsTooltip"
    matTooltip="Fields for the editable attributes of the attachment's device"
  >
    <mat-icon>memory</mat-icon>
    <span i18n="@@addDeviceAttributeFields">Add Device Attribute Fields</span>
  </button>
  }
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    [matMenuTriggerFor]="addTableMenu"
  >
    <mat-icon>table_rows</mat-icon>
    <span i18n>Add Table</span>
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #addTableMenu="matMenu">
    <button mat-menu-item (click)="addTable(FTableType.BASIC)">
      <mat-icon>table_rows</mat-icon>
      <span i18n>Basic Table</span>
    </button>
    <button mat-menu-item (click)="addTable(FTableType.DEVICES)">
      <mat-icon>checklist</mat-icon>
      <span i18n>Device Table</span>
    </button>
    <button mat-menu-item (click)="addTable(FTableType.AGGREGATE)">
      <mat-icon>functions</mat-icon>
      <span i18n>Aggregate Table</span>
    </button>
  </mat-menu>
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addDrawing()"
  >
    <mat-icon>draw</mat-icon>
    <span i18n>Add Drawing</span>
  </button>
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addSignature()"
  >
    <mat-icon>gesture</mat-icon>
    <span i18n>Add Signature</span>
  </button>

  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addAttachment()"
  >
    <mat-icon>attachment</mat-icon>
    <span i18n>Add Attachment</span>
  </button>
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addAttachmentGroup()"
  >
    <mat-icon>check_box</mat-icon>
    <span i18n>Add Attach. Group</span>
  </button>

  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addInteractiveAttachmentGroup()"
  >
    <mat-icon>touch_app</mat-icon>
    <span i18n>Add Interactive Attach.</span>
  </button>
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addDeviceAttachmentGroup()"
  >
    <mat-icon>microwave</mat-icon>
    <span i18n>Add Device Att. Group</span>
  </button>
  <button
    style="margin: 10px"
    matButton="filled"
    color="primary"
    (click)="addDocumentLink()"
  >
    <mat-icon>link</mat-icon>
    <span i18n>Document Link</span>
  </button>
  <div formArrayName="groups">
    @for (section of getGroups(editForm()); track section; let sectionIndex =
    $index) {
    <div class="app-section" [formGroupName]="sectionIndex.toString()">
      <div class="app-section-header">
        <mat-form-field style="width: 20em">
          <mat-label i18n>Section Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field style="width: 5em; margin-left: 5em">
          <mat-label i18n="@@position">Position</mat-label>
          <input
            type="number"
            matInput
            formControlName="sort"
            placeholder="Position"
            i18n-placeholder
          />
        </mat-form-field>
        <button
          matButton="outlined"
          (click)="deleteSection(sectionIndex)"
          style="margin-left: 2em"
          i18n
        >
          Delete Section
        </button>
        <button
          matButton="filled"
          color="primary"
          (click)="addItem(sectionIndex)"
          i18n
        >
          Add Field
        </button>
      </div>
      <br />
      @for (item of getFormArray($safeNavigationMigration(section?.controls.fields))?.controls ; track
      item; let i = $index) {
      <div>
        <app-item class="fxFlexFill"
          [index]="i"
          [itemForm]="getFormGroup(item)"
          [template]="editForm()"
          [productCategories]="productCategories"
          (deleteItem)="deleteItem($event, sectionIndex)"
         />
      </div>
      }
    </div>
    }
  </div>

  <div formArrayName="fields">
    @for ( field of getFields(editForm()); track field; let fieldIndex = $index)
    {
    <div class="app-field" [formGroupName]="fieldIndex.toString()">
      <app-item class="fxFlexFill"
        [index]="0"
        [itemForm]="getFormGroup(field)"
        [template]="editForm()"
        [productCategories]="productCategories"
        (deleteItem)="deleteField(fieldIndex)"
       />
    </div>
    }
  </div>

  <div formArrayName="tables">
    @for (table of getTables(editForm()); track table; let tableIndex = $index)
    {
    <div class="app-section" [formGroupName]="tableIndex.toString()">
      <button
        matIconButton
        (click)="
          formsService.getFormValidationErrors(
            editForm().get('tables')['controls'][tableIndex]
          )
        "
      >
        <mat-icon
          [style]="{
            color: formsService.hasFormValidationErrors(
              editForm().get('tables')['controls'][tableIndex]
            )
              ? 'red'
              : 'gray'
          }"
        >
          error_outline
        </mat-icon>
      </button>
      <div class="app-section-header">
        <mat-form-field>
          <mat-label i18n>Table Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field style="margin-left: 1em">
          <mat-label i18n>Pdf tag</mat-label>
          <input matInput formControlName="renderTag" />
        </mat-form-field>
        <mat-form-field style="width: 5em">
          <mat-label i18n="@@position">Position</mat-label>
          <input
            type="number"
            matInput
            formControlName="sort"
            placeholder="Position"
            i18n-placeholder
          />
        </mat-form-field>
        <button
          type="button"
          matButton="outlined"
          (click)="deleteTable(tableIndex)"
          style="margin-left: 2em"
          i18n
        >
          Delete Table
        </button>
      </div>

      <div class="app-table-charts">
        <div class="app-table-charts-head">
          <span class="app-table-charts-title" i18n>Charts</span>
          <button
            type="button"
            matButton="filled"
            color="primary"
            (click)="openChartDesigner(tableIndex)"
          >
            <mat-icon>bar_chart</mat-icon>
            <span i18n>Add chart</span>
          </button>
        </div>
        @if (getCharts(getFormGroup(table))?.length) {
        <table class="app-charts-table">
          <thead>
            <tr>
              <th i18n>Name</th>
              <th i18n>Type</th>
              <th i18n>Pdf tag</th>
              <th i18n>Data table</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (chart of getCharts(getFormGroup(table)); track chart; let ci =
            $index) {
            <tr>
              <td>{{ chart.controls.name.value || "—" }}</td>
              <td>{{ chartTypeMeta(chart.controls.chartType.value).label }}</td>
              <td>
                <code>{{ chart.controls.renderTag.value }}</code>
              </td>
              <td>
                @if (chart.controls.attachDataTable.value) {
                <mat-icon class="app-charts-table-flag">check</mat-icon>
                }
              </td>
              <td class="app-charts-table-actions">
                <button
                  type="button"
                  matIconButton
                  (click)="openChartDesigner(tableIndex, ci)"
                  aria-label="Edit chart"
                  i18n-aria-label
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  type="button"
                  matIconButton
                  (click)="
                    deleteChart(tableIndex, ci, chart.controls.name.value || '')
                  "
                  aria-label="Delete chart"
                  i18n-aria-label
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
            }
          </tbody>
        </table>
        }
      </div>
      <div class="app-cols">
        @let cols =
        getFormArray($safeNavigationMigration(table?.controls.columns)).controls;

        <div class="app-cols-toolbar">
          <span class="app-cols-title" i18n>Columns</span>
          <div class="app-cols-viewtoggle">
            <button
              type="button"
              matButton
              [class.active]="colView(tableIndex) === 'list'"
              (click)="setColView(tableIndex, 'list')"
              i18n="@@formEditColViewList"
            >
              List
            </button>
            <button
              type="button"
              matButton
              [class.active]="colView(tableIndex) === 'cards'"
              (click)="setColView(tableIndex, 'cards')"
              i18n
            >
              Cards
            </button>
          </div>
          @if (colView(tableIndex) === 'list') {
          <button
            type="button"
            matButton
            (click)="expandAllCols(tableIndex)"
            i18n
          >
            Expand all
          </button>
          <button
            type="button"
            matButton
            (click)="collapseAllCols(tableIndex)"
            i18n
          >
            Collapse all
          </button>
          }
          <span class="app-cols-spacer"></span>
          <button
            type="button"
            matButton="filled"
            color="primary"
            (click)="addTableCol(tableIndex)"
            i18n
          >
            <mat-icon>add</mat-icon>
            Add Column
          </button>
        </div>

        @if (colView(tableIndex) === 'list') {
        <div class="app-cols-list">
          @for (item of cols; track item; let i = $index) { @if
          (getFormGroup(item).controls.columnKey.value !== 'deviceUuid') { @let
          sum = colSummary(item);
          <div
            class="app-col-row"
            [class.expanded]="isColExpanded(tableIndex, i)"
          >
            <div class="app-col-row-head">
              <button
                type="button"
                class="app-col-row-toggle"
                (click)="toggleCol(tableIndex, i)"
                [attr.aria-expanded]="isColExpanded(tableIndex, i)"
              >
                <mat-icon>{{
                  isColExpanded(tableIndex, i) ? "expand_more" : "chevron_right"
                }}</mat-icon>
                <span class="app-col-badge">{{ sum.type }}</span>
                <span class="app-col-name">{{
                  sum.name || ("column " + (i + 1))
                }}</span>
                @if (sum.key) {
                <span class="app-col-key"><code>{{ sum.key }}</code></span>
                }
                <span class="app-col-dim">w {{ sum.width }}</span>
                <span class="app-col-dim">pos {{ sum.sort }}</span>
              </button>
              <button
                type="button"
                matIconButton
                color="warn"
                (click)="deleteTableCol(i, tableIndex)"
                aria-label="Delete column"
                i18n-aria-label
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            @if (isColExpanded(tableIndex, i)) {
            <div class="app-col-row-body">
              <app-table-field
                [index]="i"
                [itemForm]="getFormGroup(item)"
                [tableType]="table?.controls.type.value"
                [allProductCategories]="productCategories"
                (deleteItem)="deleteTableCol($event, tableIndex)"
              />
            </div>
            }
          </div>
          } }
        </div>
        } @else {
        <div class="app-column-container app-column-strip">
          @for (item of cols; track item; let i = $index) { @if
          (getFormGroup(item).controls.columnKey.value !== 'deviceUuid') {
          <div class="app-column">
            <app-table-field
              [index]="i"
              [itemForm]="getFormGroup(item)"
              [tableType]="table?.controls.type.value"
              [allProductCategories]="productCategories"
              (deleteItem)="deleteTableCol($event, tableIndex)"
            />
          </div>
          } }
        </div>
        }
      </div>
    </div>
    }
  </div>
  <div formArrayName="signatures">
    @for ( signature of getSignatures(editForm()); track signature; let
    signatureIndex = $index) {
    <div class="app-field" [formGroupName]="signatureIndex.toString()">
      <mat-form-field>
        <mat-label i18n>Signature description</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-checkbox style="margin-left: 2em" formControlName="optional" i18n>
        Optional
      </mat-checkbox>
      <mat-form-field style="margin-left: 1em">
        <mat-label i18n>Pdf tag</mat-label>
        <input matInput formControlName="renderTag" />
      </mat-form-field>
      <mat-checkbox formControlName="withInstallationPicture" i18n>
        Installation Picture
      </mat-checkbox>
      <mat-form-field style="width: 5em">
        <input
          type="number"
          matInput
          formControlName="sort"
          placeholder="Position"
          i18n-placeholder
        />
      </mat-form-field>
      <button
        matButton="outlined"
        (click)="deleteSignature(signatureIndex)"
        style="margin-left: 2em"
        i18n
      >
        Delete Signature
      </button>
      <br />
      <br />
    </div>
    }
  </div>
  <div formArrayName="drawings">
    @for ( drawing of getDrawings(editForm()); track drawing; let drawingIndex =
    $index) {
    <div class="app-field" [formGroupName]="drawingIndex.toString()">
      <mat-form-field>
        <mat-label i18n>Drawing Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-checkbox
        style="margin-left: 2em"
        formControlName="blankBkg"
        i18n
        (change)="
          changeBackground(
            $event,
            getFormControl(drawing.controls.base64PngBackground)
          )
        "
      >
        Blank background
      </mat-checkbox>
      <button
        matButton="elevated"
        color="accent"
        (click)="openInput(drawingIndex)"
        [disabled]="drawing.controls.blankBkg.value"
      >
        <span i18n>Select background</span>
      </button>
      <input
        id="{{ drawingIndex }}"
        hidden
        type="file"
        (change)="
          fileChange(
            $event,
            getFormControl(drawing.controls.base64PngBackground)
          )
        "
        name="file"
        accept=".jpg"
      />
      <mat-checkbox style="margin-left: 2em" formControlName="optional" i18n>
        Optional
      </mat-checkbox>
      <mat-form-field style="margin-left: 1em">
        <mat-label i18n>Pdf tag</mat-label>
        <input matInput formControlName="renderTag" />
      </mat-form-field>
      <mat-form-field style="width: 5em">
        <input
          type="number"
          matInput
          formControlName="sort"
          placeholder="Position"
          i18n-placeholder
        />
      </mat-form-field>
      <button
        matButton="outlined"
        (click)="deleteDrawing(drawingIndex)"
        style="margin-left: 2em"
        i18n
      >
        Delete Drawing
      </button>
      <br />
      <br />
    </div>
    }
  </div>
  <div formArrayName="attachments">
    @for ( attachment of getAttachments(editForm()); track attachment; let
    attachmentIndex = $index) {
    <div class="app-field" [formGroupName]="attachmentIndex.toString()">
      <mat-form-field>
        <mat-label i18n>Attachment Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field style="margin-left: 2em; flex: 1 1 20%">
        <mat-label i18n>Select Attachment Form</mat-label>
        <mat-select formControlName="templateUuid">
          @for (templ of loadedTemplates$ | async; track templ; let i = $index)
          {
          <mat-option [value]="templ.uuid">{{ templ.title }}</mat-option>
          }
        </mat-select>
        <br />
      </mat-form-field>
      <mat-checkbox style="margin-left: 2em" formControlName="newPage" i18n>
        On New Page
      </mat-checkbox>
      <mat-checkbox style="margin-left: 2em" formControlName="optional" i18n>
        Optional
      </mat-checkbox>
      <mat-checkbox style="margin-left: 2em" formControlName="filled" i18n>
        Embed filled out form
      </mat-checkbox>
      <mat-form-field style="margin-left: 1em">
        <mat-label i18n>Pdf tag</mat-label>
        <input matInput formControlName="renderTag" />
      </mat-form-field>
      <mat-form-field style="width: 5em">
        <input
          type="number"
          matInput
          formControlName="sort"
          placeholder="Position"
          i18n-placeholder
        />
      </mat-form-field>
      <button
        matButton="outlined"
        (click)="deleteAttachment(attachmentIndex)"
        style="margin-left: 2em"
        i18n
      >
        Delete Attachment
      </button>
      <br />
      <br />
    </div>
    }
  </div>
  <div formArrayName="attachmentGroups">
    @for (attGroup of getAttachmentGroups(editForm()); track attGroup; let
    attGroupIndex = $index) {
    <div class="app-section" [formGroupName]="attGroupIndex.toString()">
      <div class="app-section-header">
        <mat-form-field style="width: 20em">
          <mat-label i18n>Attachment Group Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field style="width: 14em">
          <mat-label i18n="@@selectType">Select Type</mat-label>
          <mat-select formControlName="type">
            @for (type of attachmentGroupTypes | keyvalue ; track type) {
            <mat-option [value]="+type.key">{{ type.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field style="margin-left: 1em">
          <mat-label i18n>Pdf tag</mat-label>
          <input matInput formControlName="renderTag" />
        </mat-form-field>
        <mat-form-field style="width: 6em; margin-left: 2em">
          <mat-label i18n="@@position">Position</mat-label>
          <input
            type="number"
            matInput
            formControlName="sort"
            placeholder="Position"
            i18n-placeholder
          />
        </mat-form-field>
        <button
          matButton="outlined"
          (click)="deleteAttachmentGroup(attGroupIndex)"
          style="margin-left: 2em"
          i18n
        >
          Delete Group
        </button>
        <button
          matButton="filled"
          color="primary"
          (click)="addAttachmentToGroup(attGroupIndex)"
          i18n
        >
          Add Attachment
        </button>
      </div>
      <br />
      @for (att of getFormArray($safeNavigationMigration(attGroup?.controls.attachments))?.controls; track
      att; let i = $index) {
      <div>
        <form [formGroup]="getFormGroup(att)">
          <div class="flex-row">
            <mat-form-field>
              <mat-label i18n>Attachment Name</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2em; flex: 1 1 20%">
              <mat-label i18n>Select Attachment Form</mat-label>
              <mat-select formControlName="templateUuid">
                @for (templ of loadedTemplates$ | async; track templ; let i =
                $index) {
                <mat-option [value]="templ.uuid">{{ templ.title }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 1em">
              <mat-label i18n>Pdf tag</mat-label>
              <input matInput formControlName="renderTag" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2em; width: 5em">
              <input
                type="number"
                matInput
                formControlName="sort"
                placeholder="Position"
                i18n-placeholder
              />
            </mat-form-field>
            <button
              matButton="outlined"
              (click)="deleteAttachmentFromGroup(attGroupIndex, i)"
              style="margin-left: 2em"
              i18n
            >
              Delete Attachment
            </button>
          </div>
        </form>
      </div>
      }
    </div>
    }
  </div>
  <div formArrayName="interactiveAttachmentGroups">
    @for (attGroup of getInteractiveAttachmentGroups(editForm()); track attGroup; let
      attGroupIndex = $index) {
      <div class="app-section" [formGroupName]="attGroupIndex.toString()">
        <div class="app-section-header">
          <mat-form-field style="width: 20em">
            <mat-label i18n>Attachment Group Name</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>
          <mat-form-field style="width: 6em; margin-left: 2em">
            <mat-label i18n="@@minAttach">Max no of Att</mat-label>
            <input
              type="number"
              matInput
              formControlName="minNoOfAtt"
              placeholder="MIn allowed att"
              i18n-placeholder
            />
          </mat-form-field>
          <mat-form-field style="width: 6em; margin-left: 2em">
            <mat-label i18n="@@maxAttach">Max no of Att</mat-label>
            <input
              type="number"
              matInput
              formControlName="maxNoOfAtt"
              placeholder="Max allowed att"
              i18n-placeholder
            />
          </mat-form-field>
          <mat-form-field style="margin-left: 1em">
            <mat-label i18n>Pdf tag</mat-label>
            <input matInput formControlName="renderTag" />
          </mat-form-field>
          <mat-form-field style="width: 6em; margin-left: 2em">
            <mat-label i18n="@@position">Position</mat-label>
            <input
              type="number"
              matInput
              formControlName="sort"
              placeholder="Position"
              i18n-placeholder
            />
          </mat-form-field>
          <button
            matButton="outlined"
            (click)="deleteInteractiveAttachmentGroup(attGroupIndex)"
            style="margin-left: 2em"
            i18n
          >
            Delete Group
          </button>
          <button
            matButton="filled"
            color="primary"
            (click)="addInteractiveAttachmentToGroup(attGroupIndex)"
            [disabled]="getFormArray($safeNavigationMigration(attGroup?.controls.attachments))?.controls?.length === 1"
            i18n
          >
            Add Attachment
          </button>
        </div>
        <br />
        @for (att of getFormArray($safeNavigationMigration(attGroup?.controls.attachments))?.controls; track
          att; let i = $index) {
          <div>
            <form [formGroup]="getFormGroup(att)">
              <div class="flex-row">
                <mat-form-field>
                  <mat-label i18n>Attachment Name</mat-label>
                  <input matInput formControlName="name" />
                </mat-form-field>
                <mat-form-field style="margin-left: 2em; flex: 1 1 20%">
                  <mat-label i18n>Select Attachment Form</mat-label>
                  <mat-select formControlName="templateUuid">
                    @for (templ of loadedTemplates$ | async; track templ; let i =
                      $index) {
                      <mat-option [value]="templ.uuid">{{ templ.title }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field style="margin-left: 1em">
                  <mat-label i18n>Pdf tag</mat-label>
                  <input matInput formControlName="renderTag" />
                </mat-form-field>
                <mat-form-field style="margin-left: 2em; width: 5em">
                  <input
                    type="number"
                    matInput
                    formControlName="sort"
                    placeholder="Position"
                    i18n-placeholder
                  />
                </mat-form-field>
                <button
                  matButton="outlined"
                  (click)="deleteInteractiveAttachmentFromGroup(attGroupIndex)"
                  style="margin-left: 2em"
                  i18n
                >
                  Delete Attachment
                </button>
              </div>
            </form>
          </div>
        }
      </div>
    }
  </div>
  <div formArrayName="deviceAttachmentGroups">
    @for (devAttGroup of getDeviceAttachmentGroups(editForm()); track
    devAttGroup; let devAttGroupIndex = $index) {
    <div class="app-section" [formGroupName]="devAttGroupIndex.toString()">
      <div class="app-section-header">
        <mat-form-field style="width: 20em">
          <mat-label i18n>Attachment Group Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
        <mat-form-field style="width: 14em">
          <mat-label i18n="@@selectType">Select Type</mat-label>
          <mat-select formControlName="type">
            @for (type of attachmentGroupTypes | keyvalue ; track type) {
            <mat-option [value]="+type.key">{{ type.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field style="margin-left: 1em">
          <mat-label i18n>Pdf tag</mat-label>
          <input matInput formControlName="renderTag" />
        </mat-form-field>
        <mat-form-field style="width: 5em; margin-left: 5em">
          <mat-label i18n="@@position">Position</mat-label>
          <input
            type="number"
            matInput
            formControlName="sort"
            placeholder="Position"
            i18n-placeholder
          />
        </mat-form-field>
        <button
          matButton="outlined"
          (click)="deleteDeviceAttachmentGroup(devAttGroupIndex)"
          style="margin-left: 2em"
          i18n
        >
          Delete Group
        </button>
        <button
          matButton="filled"
          color="primary"
          (click)="addDeviceAttachmentToGroup(devAttGroupIndex)"
          i18n
        >
          Add Attachment
        </button>
      </div>
      <br />
      @for (att of getFormArray( $safeNavigationMigration(devAttGroup?.controls.attachments))?.controls;
      track att; let i = $index) {
      <div>
        <form [formGroup]="getFormGroup(att)">
          <div class="flex-row">
            <mat-form-field style="margin-left: 2em; flex: 1 1 20%">
              <mat-label i18n>Select Product Category</mat-label>
              <mat-select formControlName="productCategoryUuid">
                @for (categ of productCategories; track categ; let i = $index) {
                <mat-option [value]="categ.uuid">{{ categ.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field style="margin-left: 2em">
              <mat-label i18n>Name (prefix)</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
            <mat-form-field style="margin-left: 2em; flex: 1 1 20%">
              <mat-label i18n>Select Attachment Form</mat-label>
              <mat-select formControlName="templateUuid">
                @for (templ of loadedTemplates$ | async; track templ; let i =
                $index) {
                <mat-option [value]="templ.uuid">{{ templ.title }}</mat-option>
                }
              </mat-select>
              <br />
            </mat-form-field>
            <mat-form-field style="margin-left: 1em">
              <mat-label i18n>Pdf tag</mat-label>
              <input matInput formControlName="renderTag" />
            </mat-form-field>
            <mat-form-field style="margin-left: 1em; width: 5em">
              <input
                type="number"
                matInput
                formControlName="sort"
                placeholder="Position"
                i18n-placeholder
              />
            </mat-form-field>
            <button
              matButton="outlined"
              (click)="deleteDeviceAttachmentFromGroup(devAttGroupIndex, i)"
              style="margin-left: 2em"
              i18n
            >
              Delete Attachment
            </button>
          </div>
          @if (deviceAttributeMismatch(getFormGroup(att)) | async; as missing) {
            @if (missing.length > 0) {
              <div class="app-device-attribute-mismatch">
                <mat-icon>warning</mat-icon>
                <span i18n="@@deviceAttachmentAttributeMismatch">The attachment form has device attribute fields this category doesn't have, they stay empty: {{ missing.join(", ") }}</span>
              </div>
            }
          }
        </form>
      </div>
      }
    </div>
    }
  </div>
  <div formArrayName="documents">
    @for ( document of getDocuments(editForm()); track document; let
    documentIndex = $index) {
    <div class="app-field" [formGroupName]="documentIndex.toString()">
      <mat-form-field>
        <mat-label i18n>Document Name</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field style="margin-left: 2em; flex: 1 1 20%">
        <mat-label i18n>Select Document from Library</mat-label>
        <mat-select formControlName="document" [compareWith]="compareFn">
          @for (doc of loadedDocuments$ | async; track doc; let i = $index) {
          <mat-option [value]="doc">{{ doc.name }}</mat-option>
          }
        </mat-select>
        <br />
      </mat-form-field>
      <mat-form-field style="width: 5em">
        <input
          type="number"
          matInput
          formControlName="sort"
          placeholder="Position"
          i18n-placeholder
        />
      </mat-form-field>
      <button
        matButton="outlined"
        (click)="deleteDocumentLink(documentIndex)"
        style="margin-left: 2em"
        i18n
      >
        Delete Link
      </button>
      <br />
      <br />
    </div>
    }
  </div>
</div>
